export default __webpack_public_path__ + "e196b3f1517c37f78c5d2b61b241a0c6.svg";